import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "order-summary"
};
const _hoisted_2 = {
  class: "order-summary-title"
};
const _hoisted_3 = {
  key: 0,
  class: "order-summary-subtotal-title-empty"
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  class: "order-summary-multiple-po"
};
const _hoisted_6 = {
  class: "order-summary-multiple-po-title"
};
const _hoisted_7 = {
  class: "order-summary-multiple-po-number notranslate"
};
const _hoisted_8 = {
  class: "order-summary-multiple-po-item-line-price"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_10 = {
  class: "order-summary-subtotal-multi-value"
};
const _hoisted_11 = {
  class: "order-summary-subtotal-multi-value-currency"
};
const _hoisted_12 = {
  key: 0,
  class: "order-summary-pay-with-credit"
};
const _hoisted_13 = {
  key: 1,
  class: "order-summary-tax-message"
};
const _hoisted_14 = {
  key: 2,
  class: "order-summary-tax-message"
};
const _hoisted_15 = {
  class: "order-summary-checkout-info"
};
const _hoisted_16 = {
  class: "order-summary-buttons"
};
const _hoisted_17 = ["aria-label", "disabled"];
const _hoisted_18 = {
  class: "empty-cart-modal-header",
  "aria-label": "Empty Cart Modal Header"
};
const _hoisted_19 = {
  class: "reset-modal-modal-text",
  "aria-label": "Empty Cart Modal Body"
};
const _hoisted_20 = ["aria-label"];
const _hoisted_21 = ["aria-label"];
const _hoisted_22 = ["aria-label"];
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = ["arial-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  const _component_ChevronIcon = _resolveComponent("ChevronIcon");
  const _component_CheckBox = _resolveComponent("CheckBox");
  const _component_DcModal = _resolveComponent("DcModal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_LoadingDots, {
    loading: $data.loading
  }, null, 8, ["loading"]), _createElementVNode("h4", _hoisted_2, _toDisplayString($options.getLabel('order.summary.Title')), 1), !$options.hasItemsInCart() ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($options.getLabel('subtotal')), 1)) : _createCommentVNode("", true), !$options.hasItemsInCart() && $options.cartCount > 25 ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    type: "button",
    class: "order-summary-buttons-timeout-remove",
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers($event => $options.toggleModal(), ["prevent"]), ["enter"])),
    onClick: _cache[1] || (_cache[1] = $event => $options.toggleModal())
  }, _toDisplayString($options.getLabel('button.empty.cart.UPPER')), 33)) : _createCommentVNode("", true), $options.hasItemsInCart() ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(["order-summary-multiple-po-title-wrapper", {
      'expanded': $data.displayTotalsByPo
    }])
  }, [_createElementVNode("p", _hoisted_6, _toDisplayString($options.getLabel('text.search.option.poNo')), 1), _withDirectives(_createVNode(_component_ChevronIcon, {
    tabindex: "0",
    onClick: $options.toggleTotalsByPo,
    onKeydown: [_withKeys(_withModifiers($options.toggleTotalsByPo, ["prevent"]), ["enter"]), _withKeys(_withModifiers($options.toggleTotalsByPo, ["prevent"]), ["space"])]
  }, null, 8, ["onClick", "onKeydown"]), [[_vShow, $options.hasTotalsByPo]])], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.totalsByPo, (poEntry, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: index,
      class: "order-summary-multiple-po-item"
    }, [_createElementVNode("span", _hoisted_7, _toDisplayString(poEntry.poNumber), 1), _createElementVNode("span", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(poEntry.totalsByPoList, (currencyEntry, idx) => {
      return _openBlock(), _createElementBlock("span", {
        key: idx
      }, [_createTextVNode(_toDisplayString(currencyEntry.totalsByCurrency.subtotalAmountFormatted) + " " + _toDisplayString(currencyEntry.currency), 1), _hoisted_9]);
    }), 128))])])), [[_vShow, $data.displayTotalsByPo]]);
  }), 128)), !$options.hasTotalsByPo ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($options.subTotals(), (subtotal, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("p", _hoisted_10, [_createTextVNode(_toDisplayString(subtotal) + " ", 1), _createElementVNode("span", _hoisted_11, _toDisplayString($options.getCurrencies()[index]), 1)])]);
  }), 128)) : _createCommentVNode("", true)]), $options.canPayByCreditCard() ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_CheckBox, {
    name: "order-summary-pay-width-credit",
    label: $options.getLabel('checkout.pay.by.creditcard'),
    modelValue: $data.creditCardSelected,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.creditCardSelected = $event),
    isDisabled: $options.isOnlyCreditCardPayment()
  }, null, 8, ["label", "modelValue", "isDisabled"])])) : _createCommentVNode("", true), $data.isIndia ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($options.getLabel('cart.order.summary.message.checkout.india')), 1)) : _createCommentVNode("", true), $data.isExchangeMessage ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($options.getLabel('review.business.rules')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, _toDisplayString($options.getLabel('cart.rightRail.des.text')), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
    type: "button",
    class: "order-summary-buttons-remove",
    onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers($event => $options.toggleModal(), ["prevent"]), ["enter"])),
    onClick: _cache[4] || (_cache[4] = $event => $options.toggleModal())
  }, _toDisplayString($options.getLabel('button.empty.cart.UPPER')), 33), _createElementVNode("button", {
    type: "button",
    class: "order-summary-buttons-checkout",
    "aria-label": $options.getLabel('button.checkout.UPPER'),
    disabled: $props.isButtonDisabled,
    onClick: _cache[5] || (_cache[5] = $event => $options.onCheckoutClicked()),
    onKeydown: _cache[6] || (_cache[6] = _withKeys($event => $options.onCheckoutClicked(), ["enter"]))
  }, _toDisplayString($options.getLabel('button.checkout.UPPER')), 41, _hoisted_17)])])) : _createCommentVNode("", true)]), $data.showEmptyCartModal ? (_openBlock(), _createBlock(_component_DcModal, {
    key: 0,
    onModalClose: _cache[9] || (_cache[9] = $event => $options.toggleModal())
  }, {
    header: _withCtx(() => [_createElementVNode("h4", _hoisted_18, _toDisplayString($options.getLabel('button.empty.cart.UPPER')), 1)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, _toDisplayString($props.removeMessage || $options.getLabel('cart.page.emptyCart.popup.message')), 1)])]),
    footer: _withCtx(() => [_createElementVNode("button", {
      class: "empty-cart-modal-button-no",
      type: "submit",
      onClick: _cache[7] || (_cache[7] = $event => $options.toggleModal()),
      "aria-label": $options.getLabel('button.no.UPPER')
    }, _toDisplayString($options.getLabel('button.no.UPPER')), 9, _hoisted_20), _createElementVNode("button", {
      class: "empty-cart-modal-button-yes",
      type: "submit",
      onClick: _cache[8] || (_cache[8] = $event => $options.removeAll()),
      "aria-label": $options.getLabel('button.yes.UPPER')
    }, _toDisplayString($options.getLabel('button.yes.UPPER')), 9, _hoisted_21)]),
    _: 1
  })) : _createCommentVNode("", true), $data.showSimulateErrorModal ? (_openBlock(), _createBlock(_component_DcModal, {
    key: 1,
    onModalClose: _cache[11] || (_cache[11] = $event => $options.toggleSimulateModal())
  }, {
    header: _withCtx(() => [_createElementVNode("h4", {
      "aria-label": $options.getLabel('error')
    }, _toDisplayString($options.getLabel('error')), 9, _hoisted_22)]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.simulateErrorMessages, (simulateErrorMessage, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "simulate-error",
        key: index
      }, [simulateErrorMessage.includes('zeroPricingError') ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString($options.getPricingErrorMessage(simulateErrorMessage)), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(simulateErrorMessage), 1))]);
    }), 128))]),
    footer: _withCtx(() => [_createElementVNode("button", {
      class: "simulate-modal-close",
      type: "submit",
      onClick: _cache[10] || (_cache[10] = $event => $options.toggleSimulateModal()),
      "arial-label": $options.getLabel('button.close.UPPER')
    }, _toDisplayString($options.getLabel('button.close.UPPER')), 9, _hoisted_25)]),
    _: 1
  })) : _createCommentVNode("", true)], 64);
}